module.exports = {
	"SAY_HI": "Hello",
	"EDIT_TAB": "Edit / Create",
	"PREVIEW_TAB": "Preview",
	"WIZARD_LINES": "lines",
	"WIZARD_LAYOUT": "layout",
	"WIZARD_CONTROLS": "controls",
	"WIZARD_SAVE": "save",
	"PAGER_PREVIOUS": "Previous",
	"PAGER_NEXT": "Next",
	"COMMAND_PANEL": "Command",
	"VISUAL_PANEL": "Visual",
	"ADD_NEW_LINE": "Add a new line",
	"SELECTED_LINE": "Selected line",
	"NUMBER_OF_COLUMN": "number of columns",
	"APPLY_CTRL2COL": "Apply controls to columns",
	"CLIC_TAP_2_OPEN": "Click / Tap on column to open control selection",
	"SELECT_2_APPLY_COL": "Select desired control and valid to apply it to column",
	"CUSTOM_SUBMIT_BTN": "Customize Submit button Text",
	"CUSTOM_CANCEL_BTN": "Customize Cancel button Text",
	"NAME_THIS_FORM": "Name this form",
	"SAVE_THIS_FORM": "save this form",
	"FINAL_STEP": "Final Step : form preview",
	"DATA_MODEL": "DATA MODEL",
	"FIELDS_MODEL": "FIELDS MODEL (ready to save to database one)",
	"SELECT_A_CTRL": "Select a control",
	"SELECT_CTRL_IN_LIST": "Select a control in the list below",
	"COL_WILL_BE_BLANK": "Column will be blank",
	"EDIT_PROPERTIES": "Edit properties",
	"HEADER_TEXT": "Header text",
	"ADD_EDIT_HEADER_HERE": "Add / edit header text here",
	"SUBTITLE_TEXT": "Subtitle text",
	"ADD_EDIT_SUBTIL_HERE": "Add / edit subtitle text here",
	"LABEL_TEXT": "Label text",
	"ADD_EDIT_LABEL_HERE": "Add / edit control label here",
	"PLACEHOLDER": "placeholder",
	"ADD_EDIT_PLACEHOLD": "Add / edit placeholder text here",
	"REQUIRED": "Required",
	"DESCRIPTION": "Description",
	"ADDEDIT_DESCRIPTION": "Add / edit description here",
	"DATE_FORMAT": "Date format",
	"ADD_NEW_RADIO": "Add new radio",
	"ADD_RADIO_PLACEHOLD": "add new radio",
	"EDIT_REMOVE_RADIO": "Edit/Remove radio",
	"NO_RADIO_ADD_NEW": "no radio : add new radio values",
	"SEARCH_4_OPTION": "search for option",
	"ADD": "add",
	"ORDER": "order",
	"OPTION": "option",
	"GROUP": "group",
	"ADD_NEW_OPTIONS": "Add new options",
	"ADD_A_NEW_OPTION": "add new option",
	"EDIT_REMOVE_OPTIONS": "Edit/Remove options",
	"NO_OPTION_ADD_NEW": "no option : add new options",
	"ADD_NEW_GROUPS": "Add new groups",
	"ADD_A_NEW_GROUP": "Add new group",
	"EDIT_GROUPS_OPTIONS": "Edit/Remove options/groups",
	"NO_GROUP_ADD_NEW": "add new groups",
	"OK": "OK",
	"CANCEL": "Cancel"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/stepway/i18n/local-en.json
// module id = 13
// module chunks = 0